
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/important-notices",
      function () {
        return require("private-next-pages/important-notices.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/important-notices"])
      });
    }
  